import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { useIntersection } from '../../hook/useIntersection';
import style from './style.module.scss';

export const Loading = ({ classNames, isLoading, onViewPortAppear, isTextPrinted = true }) => {
    const [activeDotIndex, setActiveDotIndex] = useState(0);
    const ref = useRef();
    const inViewport = useIntersection(ref, '0px', 0.5);

    // Animation
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveDotIndex((c) => (c === 3 ? 1 : c + 1));
        }, 400);

        return () => clearTimeout(interval);
    }, []);

    // Activation of loading
    useEffect(() => {
        if (inViewport) onViewPortAppear();
    }, [inViewport, onViewPortAppear]);

    return (
        <div ref={ref} className={clsx(style.block, classNames)}>
            {isLoading && (
                <>
                    {inViewport && <div style={{ backgroundColor: '#fff' }} />}
                    <div className={style.dots}>
                        <span className={activeDotIndex === 1 ? style.activeDot : undefined} />
                        <span className={activeDotIndex === 2 ? style.activeDot : undefined} />
                        <span className={activeDotIndex === 3 ? style.activeDot : undefined} />
                    </div>
                    {isTextPrinted && <div className={style.text}>Chargement...</div>}
                </>
            )}
        </div>
    );
};
